import React from "react";
import dayjs from "dayjs";

const EventList = ({ events, selectedId, onSelect }) => (
  <ul className="space-y-2">
    {events.map((event) => (
      <li
        key={event.id}
        onClick={() => onSelect(event)}
        className={`flex items-center justify-between p-3 rounded-lg cursor-pointer hover:bg-pink-100 ${
          selectedId === event.id ? "bg-pink-200" : "bg-gray-100"
        }`}
      >
        <div>
          <h3 className="font-semibold">{event.title}</h3>
          <p className="text-sm text-gray-500">
            {dayjs(event.date?.toDate?.()).format("MMM D, YYYY")}
          </p>
        </div>
        <span
          className="w-5 h-5 rounded-full border ml-4"
          style={{
            backgroundColor: event.displaySettings?.accentColor || event.color,
          }}
        ></span>
      </li>
    ))}
  </ul>
);

export default EventList;
